module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    class: {
      xs6: !_vm.small
    }
  }, [_c('pie-chart', {
    attrs: {
      "chart-data": _vm.data,
      "options": _vm.options,
      "width": _vm.size,
      "height": _vm.size
    }
  })], 1), _vm._v(" "), (!_vm.small && _vm.$auth.hasRole('GROUP_ADMIN')) ? _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.$t('logicStorageReport.displayFilters')))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('loadable', {
    attrs: {
      "loading": !_vm.groups
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('search'),
      "prepend-icon": "search",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "datatable table table-crud elevation-1"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "show-check"
  }, [_vm._v(_vm._s(_vm.$t('headers.show')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('headers.name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('headers.totalSpace')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('headers.takenSpace')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('headers.disabledSpace')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _vm._l((_vm.filtered), function(group) {
    return _c('tbody', {
      key: group.id
    }, [_c('tr', [_c('td', [_c('v-checkbox', {
      staticClass: "ma-0 pa-0",
      model: {
        value: (group.checked),
        callback: function($$v) {
          _vm.$set(group, "checked", $$v)
        },
        expression: "group.checked"
      }
    })], 1), _vm._v(" "), _c('td', {
      on: {
        "click": function($event) {
          group.showChildren = !group.showChildren
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(group.showChildren ? 'expand_less' : 'expand_more'))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(group.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$format.fileSize(group.total)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$format.fileSize(group.used)) + " "), _c('div', {
      staticClass: "percentage"
    }, [_vm._v(_vm._s(_vm.$format.ratio(group.used, group.total)))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$format.fileSize(group.inactive)) + " "), _c('div', {
      staticClass: "percentage"
    }, [_vm._v(_vm._s(_vm.$format.ratio(group.inactive, group.total)))])]), _vm._v(" "), _c('td', [_c('v-btn', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: _vm.$t('logicStorageReport.showOnly')
        }),
        expression: "{ content: $t('logicStorageReport.showOnly') }"
      }],
      staticClass: "pa-0 ma-0",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.showOnly(group, null)
        }
      }
    }, [_c('v-icon', [_vm._v("arrow_forward")])], 1)], 1)]), _vm._v(" "), _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (group.showChildren),
        expression: "group.showChildren"
      }]
    }, [_c('td', {
      attrs: {
        "colspan": "200"
      }
    }, [_c('table', {
      staticClass: "datatable table table-crud ma-3 subtable elevation-1"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "show-check"
    }, [_vm._v(_vm._s(_vm.$t('headers.show')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('headers.name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('headers.quota')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('headers.takenSpace')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((group.filtered), function(company) {
      return _c('tr', {
        key: company.id
      }, [_c('td', [_c('v-checkbox', {
        staticClass: "ma-0 pa-0",
        model: {
          value: (company.checked),
          callback: function($$v) {
            _vm.$set(company, "checked", $$v)
          },
          expression: "company.checked"
        }
      })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(company.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$format.fileSize(company.quota || 0)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$format.fileSize(company.recordingsSize || 0)) + " "), _c('div', {
        staticClass: "percentage"
      }, [_vm._v(_vm._s(_vm.$format.ratio(company.recordingsSize, company.quota)))])]), _vm._v(" "), _c('td', [_c('v-btn', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip",
          value: ({
            content: _vm.$t('logicStorageReport.showOnly')
          }),
          expression: "{ content: $t('logicStorageReport.showOnly') }"
        }],
        staticClass: "pa-0 ma-0",
        attrs: {
          "icon": ""
        },
        on: {
          "click": function($event) {
            _vm.showOnly(group, company)
          }
        }
      }, [_c('v-icon', [_vm._v("arrow_forward")])], 1)], 1)])
    }))])])])])
  })], 2)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.$t('targetsReport.title')))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('targets-report')], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c29dd44","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports/LogicStorageReport.vue
// module id = 1068
// module chunks = 1